import { createSlice, createSelector } from "@reduxjs/toolkit";
import { filterSarmsForUser } from '../../../utils/filtering';

const initialState = {
  swarms: null,
  events: null,
  userBuys: null,
  blackListedVenues: null
};

const swarmsForBeeSlice = createSlice({
  name: "swarmsForBee",
  initialState,
  reducers: {
    setSwarms: (state, action) => {
      state.swarms = action.payload;
    },
    clearSwarms: (state) => {
      state.swarms = null;
    },
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    clearEvents: (state) => {
      state.events = null;
    },
    setUserBuys: (state, action) => {
      state.userBuys = action.payload;
    },
    clearUserBuys: (state) => {
      state.userBuys = null;
    },
    setBlackListedVenues: (state, action) => {
      state.blackListedVenues = action.payload;
    },
    clearBlackListedVenues: (state) => {
      state.blackListedVenues = null;
    },
    updateBeeSwarmSoftClosing:(state,action)=>{
      console.log("updateBeeSwarmSoftClosing: ", action.payload)
      const swarm = action.payload;
        
      if(state.swarms == null || state.swarms == undefined){
        console.log("updateSwarm, swarm: " + swarm.id + " store is null adding swarm, OK");
        state.swarms= [swarm];
        return;
      }

      const swarmIndex = state?.swarms?.findIndex((s) => s.id === swarm.id);
      
      if (swarmIndex !== -1) {
        if(state.swarms[swarmIndex].running && !swarm.running){ // swarm has been closed
          // used to notify the bee
          let inMemorySwarm = {...swarm, running:true, hasBeenClosed: true }
          state.swarms[swarmIndex] = inMemorySwarm;
          console.log("updateBeeSwarmSoftClosing: swarm has been closed: ", inMemorySwarm)
        }else{
          // just update the swarm
          console.log("updateBeeSwarmSoftClosing: swarm has not been closed: ", swarm)
          state.swarms[swarmIndex] = swarm;
        }
      } else {
        console.log("updateBeeSwarmSoftClosing: swarm not found in store, adding it: ", swarm)
          state.swarms.push(swarm);
      }
    },
    updateBeeSwarm: (state, action) => {
        const swarm = action.payload;
        
        if(state.swarms == null || state.swarms == undefined){
          console.log("updateBeeSwarm, swarm: " + swarm.id + " store is null adding swarm, OK");
          state.swarms= [swarm];
          return;
        }

        const swarmIndex = state?.swarms?.findIndex((s) => s.id === swarm.id);
        
        if (swarmIndex !== -1) {
          state.swarms[swarmIndex] = swarm;
        } else {
            state.swarms.push(swarm);
        }
    },
  }
});

export const { 
  setSwarms, 
  clearSwarms, 
  setEvents, 
  clearEvents,
  setUserBuys,
  clearUserBuys,
  setBlackListedVenues,
  clearBlackListedVenues,
  updateBeeSwarmSoftClosing,
  updateBeeSwarm
} = swarmsForBeeSlice.actions;

// Basic selectors
export const selectSwarms = (state) => state.swarmsForBee.swarms;
export const selectEvents = (state) => state.swarmsForBee.events;
export const selectUserBuys = (state) => state.swarmsForBee.userBuys;
export const selectBlackListedVenues = (state) => state.swarmsForBee.blackListedVenues;

// Auxiliary function to merge swarms with events
const mergeSwarmsAndEvents = (swarms, events) => {
  if (!swarms || !events) return [];
  
  return swarms.map(swarm => {
    const event = events.find(e => e.bteId === swarm.bteId);
    return { ...swarm, event };
  });
};

// Auxiliary function to round salesDate seconds
const roundSalesDateSeconds = (swarms) => {
  if (!swarms) return [];
  
  return swarms.map(swarm => {
    if (swarm.salesDate) {
      let dateParts = swarm.salesDate.split(":");
      dateParts[2] = "00";
      swarm.salesDate = dateParts.join(":");
    }
    return swarm;
  });
};

// Complex selector to get filtered and processed swarms
export const selectFilteredSwarms = createSelector(
  [
    selectSwarms,
    selectEvents,
    selectBlackListedVenues,
    selectUserBuys
  ],
  (swarms, events, blVenues, userBuys) => {
    if (!swarms || !events || !blVenues || !userBuys) {
      return [];
    }
    
    // Filter active swarms
    const activeSwarms = swarms.filter(s => s.running === true) || [];
    
    // Apply user filter
    let swarmsFiltered = filterSarmsForUser(activeSwarms, blVenues, events, userBuys);
    
    // Merge with events
    swarmsFiltered = mergeSwarmsAndEvents(swarmsFiltered, events);
    
    // Round salesDate seconds
    swarmsFiltered = roundSalesDateSeconds(swarmsFiltered);
    
    return swarmsFiltered;
  }
);

// Selector for active swarms
export const selectRunningSwarms = createSelector(
  [selectSwarms],
  (swarms) => swarms ? swarms.filter(s => s.running === true) : []
);

export default swarmsForBeeSlice.reducer;